export const resetPasswordModelToJSON = (obj: IResetPassword): IResetPasswordJson => {
	const { token, passwordConfirmation, ...rest } = obj

	return {
		password_reset_token: token,
		password_confirmation: passwordConfirmation,
		...rest,
	}
}
